import { createAction } from '@reduxjs/toolkit';

export const GET_SCHEMAS = 'GET_SCHEMAS';
export const GETTING_SCHEMAS = 'GETTING_SCHEMAS';
export const GETTING_SCHEMAS_SUCCEEDED = 'GETTING_SCHEMAS_SUCCEEDED';
export const GETTING_SCHEMAS_FAILED = 'GETTING_SCHEMAS_FAILED';

export const GET_SCHEMA = 'GET_SCHEMA';
export const GETTING_SCHEMA = 'GETTING_SCHEMA';
export const GETTING_SCHEMA_FAILED = 'GETTING_SCHEMA_FAILED';
export const GETTING_SCHEMA_SUCCEEDED = 'GETTING_SCHEMA_SUCCEEDED';

export const GET_PAGINATED_SCHEMAS = 'GET_PAGINATED_SCHEMAS';
export const GETTING_PAGINATED_SCHEMAS = 'GETTING_PAGINATED_SCHEMAS';
export const GETTING_PAGINATED_SCHEMAS_SUCCEEDED =
  'GETTING_PAGINATED_SCHEMAS_SUCCEEDED';
export const GETTING_PAGINATED_SCHEMAS_FAILED =
  'GETTING_PAGINATED_SCHEMAS_FAILED';

export const GET_SCHEMA_KEYS = 'GET_SCHEMA_KEYS';
export const GETTING_SCHEMA_KEYS = 'GETTING_SCHEMA_KEYS';
export const GETTING_SCHEMA_KEYS_SUCCEEDED = 'GETTING_SCHEMA_KEYS_SUCCEEDED';
export const GETTING_SCHEMA_KEYS_FAILED = 'GETTING_SCHEMA_KEYS_FAILED';

export const CREATE_SCHEMA = 'CREATE_SCHEMA';
export const CREATING_SCHEMA = 'CREATING_SCHEMA';
export const CREATING_SCHEMA_SUCCEEDED = 'CREATING_SCHEMA_SUCCEEDED';
export const CREATING_SCHEMA_FAILED = 'CREATING_SCHEMA_FAILED';

export const UPDATE_SCHEMA = 'UPDATE_SCHEMA';
export const UPDATING_SCHEMA = 'UPDATING_SCHEMA';
export const UPDATING_SCHEMA_SUCCEEDED = 'UPDATING_SCHEMA_SUCCEEDED';
export const UPDATING_SCHEMA_FAILED = 'UPDATING_SCHEMA_FAILED';

export const SET_CURRENT_SCHEMA = 'SET_CURRENT_SCHEMA';
export const UNSET_CURRENT_SCHEMA = 'UNSET_CURRENT_SCHEMA';

export const SET_CURRENT_SCHEMA_DETAILS = 'SET_CURRENT_SCHEMA_DETAILS';
export const UNSET_CURRENT_SCHEMA_DETAILS = 'UNSET_CURRENT_SCHEMA_DETAILS';

export const ACTIVATE_OR_DEACTIVATE_SCHEMA = 'ACTIVATE_OR_DEACTIVATE_SCHEMA';
export const ACTIVATE_OR_DEACTIVATE_SCHEMA_SUCCEEDED =
  'ACTIVATE_OR_DEACTIVATE_SCHEMA_SUCCEEDED';
export const ACTIVATE_OR_DEACTIVATE_SCHEMA_FAILED =
  'ACTIVATE_OR_DEACTIVATE_SCHEMA_FAILED';

export const GET_EVENT_TYPES = 'GET_EVENT_TYPES';
export const GETTING_EVENT_TYPES_SUCCEEDED = 'GETTING_EVENT_TYPES_SUCCEEDED';
export const GETTING_EVENT_TYPES_FAILED = 'GETTING_EVENT_TYPES_FAILED';

export const LOADING_CURRENT_SCHEMA = 'LOADING_CURRENT_SCHEMA';

export const GET_EVENT_IDENTIFIER_VALUES = 'GET_EVENT_IDENTIFIER_VALUES';
export const GETTING_EVENT_IDENTIFIER_VALUES_SUCCEEDED =
  'GETTING_EVENT_IDENTIFIER_VALUES_SUCCEEDED';

export const UPDATE_SCHEMA_FILTERS = 'UPDATE_SCHEMA_FILTERS';
export const RESET_SCHEMA_FILTERS = 'RESET_SCHEMA_FILTERS';

export const getSchemas = createAction(GET_SCHEMAS);
export const gettingSchemas = createAction(GETTING_SCHEMAS);
export const gettingSchemasSucceeded = createAction(GETTING_SCHEMAS_SUCCEEDED);
export const gettingSchemasFailed = createAction(GETTING_SCHEMAS_FAILED);

export const getSchema = createAction(GET_SCHEMA);
export const gettingSchema = createAction(GETTING_SCHEMA);
export const gettingSchemaSucceeded = createAction(GETTING_SCHEMA_SUCCEEDED);
export const gettingSchemaFailed = createAction(GETTING_SCHEMA_FAILED);

export const getPaginatedSchemas = createAction(GET_PAGINATED_SCHEMAS);
export const gettingPaginatedSchemasSucceeded = createAction(
  GETTING_PAGINATED_SCHEMAS_SUCCEEDED
);

export const gettingPaginatedSchemasFailed = createAction(
  GETTING_PAGINATED_SCHEMAS_FAILED
);

export const gettingPaginatedSchemas = createAction(GETTING_PAGINATED_SCHEMAS);

export const getSchemaKeys = createAction(GET_SCHEMA_KEYS);
export const gettingSchemaKeys = createAction(GETTING_SCHEMA_KEYS);
export const gettingSchemaKeysSucceeded = createAction(
  GETTING_SCHEMA_KEYS_SUCCEEDED
);
export const gettingSchemaKeysFailed = createAction(GETTING_SCHEMA_KEYS_FAILED);

export const createSchema = createAction(CREATE_SCHEMA);
export const creatingSchema = createAction(CREATING_SCHEMA);
export const creatingSchemaSucceeded = createAction(CREATING_SCHEMA_SUCCEEDED);
export const creatingSchemaFailed = createAction(CREATING_SCHEMA_FAILED);

export const updateSchema = createAction(UPDATE_SCHEMA);
export const updatingSchema = createAction(UPDATING_SCHEMA);
export const updatingSchemaSucceeded = createAction(UPDATING_SCHEMA_SUCCEEDED);
export const updatingSchemaFailed = createAction(UPDATING_SCHEMA_FAILED);

export const setCurrentSchema = createAction(SET_CURRENT_SCHEMA);
export const unsetCurrentSchema = createAction(UNSET_CURRENT_SCHEMA);

export const setCurrentSchemaDetails = createAction(SET_CURRENT_SCHEMA_DETAILS);
export const unsetCurrentSchemaDetails = createAction(
  UNSET_CURRENT_SCHEMA_DETAILS
);

export const activateOrDeactivateSchema = createAction(
  ACTIVATE_OR_DEACTIVATE_SCHEMA
);
export const activateOrDeactivateSchemaSucceeded = createAction(
  ACTIVATE_OR_DEACTIVATE_SCHEMA_SUCCEEDED
);
export const activateOrDeactivateSchemaFailed = createAction(
  ACTIVATE_OR_DEACTIVATE_SCHEMA_FAILED
);

export const getEventTypes = createAction(GET_EVENT_TYPES);
export const gettingEventTypesSucceeded = createAction(
  GETTING_EVENT_TYPES_SUCCEEDED
);
export const gettingEventTypesFailed = createAction(GETTING_EVENT_TYPES_FAILED);

export const loadingCurrentSchema = createAction(LOADING_CURRENT_SCHEMA);

export const getEventIdentifierValues = createAction(
  GET_EVENT_IDENTIFIER_VALUES
);
export const gettingEventIdentifierValuesSucceeded = createAction(
  GETTING_EVENT_IDENTIFIER_VALUES_SUCCEEDED
);

export const updateSchemaFilters = createAction(UPDATE_SCHEMA_FILTERS);
export const resetSchemaFilters = createAction(RESET_SCHEMA_FILTERS);

export const GET_SCHEMA_OPTIONS = 'GET_SCHEMA_OPTIONS';

export const GETTING_SCHEMA_OPTIONS_SUCCEEDED =
  'GETTING_SCHEMA_OPTIONS_SUCCEEDED';

export const GETTING_SCHEMA_OPTIONS_FAILED = 'GETTING_SCHEMA_OPTIONS_FAILED';

export const getSchemaOptions = (fieldType) => ({
  type: GET_SCHEMA_OPTIONS,
  payload: { fieldType }
});

export const gettingSchemaOptionsSucceeded = (payload) => ({
  type: GETTING_SCHEMA_OPTIONS_SUCCEEDED,
  payload
});

export const gettingSchemaOptionsFailed = (error) => ({
  type: GETTING_SCHEMA_OPTIONS_FAILED,
  payload: error
});
